(() => {
  const pages = {
    '/pages/off-skates-technique': [
      ['.one-technique-class:nth-of-type(1)', 'body-positioning-class-one'],
      ['.one-technique-class:nth-of-type(2)', 'body-positioning-class-two'],
      ['.one-technique-class:nth-of-type(3)', 'off-skates-jump-class'],
    ],
    '/pages/off-skates-strength-fitness': [
      ['.one-strength-class:nth-of-type(1)', 'skater-strength-and-fitness'],
      ['.one-strength-class:nth-of-type(2)', 'cardio-core'],
      ['.one-strength-class:nth-of-type(3)', 'upper-resistance'],
      ['.one-strength-class:nth-of-type(4)', 'lower-resistance'],
    ],
  };

  const anchors = pages[location.pathname];
  if (!anchors) return;

  const install = () => {
    anchors.forEach(([selector, id]) => {
      const target = document.querySelector(selector);
      if (target && !target.id) target.id = id;
    });
    const target = location.hash && document.getElementById(location.hash.slice(1));
    if (target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();
